import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { fuenteI } from 'src/app/modelos/fuentes.interface';
import { TipoUsuarioI } from 'src/app/modelos/tipoUsuario.interface';
import { UsuarioI } from 'src/app/modelos/usuario.interface';
import { ApiService } from 'src/app/servicios/api/api.service';
import { ToastrService } from 'ngx-toastr';
import { DivipolaI } from 'src/app/modelos/Divipola';
import { UsuariosServiceService } from 'src/app/servicios/usuarios/UsuariosService.service';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-editarusuario',
  templateUrl: './editarusuario.component.html',
  styleUrls: ['./editarusuario.component.css']
})
export class EditarusuarioComponent implements OnInit {

  datosUsuarioEdit : UsuarioI = new UsuarioI;
  fuenteUsuario : fuenteI = new fuenteI;
  tiposUsuarioDane : TipoUsuarioI[];
  tipoUsuDaneSeclte : TipoUsuarioI = new TipoUsuarioI;
  btnguardar : Boolean;
  email1 = new FormControl('',[Validators.required, Validators.email, Validators.pattern(/^[A-Za-z0-9@._-]*$/)]);
  email2 = new FormControl('',[Validators.required, Validators.email, Validators.pattern(/^[A-Za-z0-9@._-]*$/)]);
  continuar : Boolean;
  AuxDeptoMuni : DivipolaI = new DivipolaI;

  tipoUsuarioDane : number;

  constructor(
    private activerouter: ActivatedRoute,
    private router: Router,
    private api: ApiService,
    private toastr: ToastrService,
    private usuarioService: UsuariosServiceService
    ) { }

  ngOnInit(): void {
    this.btnguardar = false;

    this.datosUsuarioEdit = new UsuarioI;
    this.fuenteUsuario = new fuenteI;

    let UsuarioId = this.activerouter.snapshot.paramMap.get('id');
    this.api.obtUsuarioById(UsuarioId).subscribe(data=>{
      this.datosUsuarioEdit = data;
      this.tipoUsuarioDane = data.tipoUsuario.idTipoUsuario;
      this.email1.setValue(this.datosUsuarioEdit.correo);
      this.email2.setValue(this.datosUsuarioEdit.correo);
      if (this.datosUsuarioEdit.tipoUsuario.nombreTipo != "DANE"){
        this.api.getFuenteById(this.datosUsuarioEdit.fuente.id).subscribe(data=>{
          this.fuenteUsuario = data;
          this.api.getMuniByCodigo(this.fuenteUsuario.muni).subscribe(depmuni=>{
            this.AuxDeptoMuni = depmuni;
          },error=>{
            console.log(error);
          });
        },error=>{
          console.log(error);
        });
      }
    },error=>{
      console.log(error);
    });

    this.api.getTipobtenerTipoUDANE().subscribe(data=>{
      this.tiposUsuarioDane = data;
    },error=>{
      console.log(error);
    });
  }

  guardar(){

    this.btnguardar = true;
    this.continuar = true;

    if (this.datosUsuarioEdit.tipoIdent == ""){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Seleccione un tipo de identificación.', 'Advertencia!');
    } else if (this.datosUsuarioEdit.identificacion == ""){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Ingresar número de identificación.', 'Advertencia!');
    } else if (this.datosUsuarioEdit.identificacion.length < 6){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('El número de identificación debe contar con mínimo 6 caracteres.', 'Advertencia!');
    } else if (this.datosUsuarioEdit.identificacion.length >10){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('El número de identificación debe contar con máximo 10 caracteres.', 'Advertencia!');
    } else if (this.datosUsuarioEdit.nombres == ""){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Ingresar nombres.', 'Advertencia!');
    } else if (this.datosUsuarioEdit.nombres.length < 10){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('El nombre del responsable debe contar con mínimo 10 caracteres.', 'Advertencia!');
    } else if (this.datosUsuarioEdit.nombres.length > 100){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('El nombre del responsable debe contar con máximo 100 caracteres.', 'Advertencia!');
    } else if (this.email1.value == ""){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Ingresar correo.', 'Advertencia!');
    } else if (this.email1.hasError('required')){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Ingresar correo.', 'Advertencia!');
    } else if (this.email1.hasError('email')){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Correo no valido.', 'Advertencia!');
    } else if (this.email1.hasError('pattern')){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Correo contiene caracteres no permitidos.', 'Advertencia!');
    } else if (this.email1.value.length < 10 ){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Correo debe tener mínimo 10 caracteres.', 'Advertencia!');
    } else if (this.email1.value.length > 40 ){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Correo debe tener máximo 40 caracteres.', 'Advertencia!');
    } else if (this.email2.value == ""){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Confirmar correo .', 'Advertencia!');
    } else if (this.email2.hasError('required')){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Confirmar correo.', 'Advertencia!');
    } else if (this.email2.hasError('email')){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Confirmar correo no valido.', 'Advertencia!');
    } else if (this.email2.hasError('pattern')){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Confirmar correo contiene caracteres no permitidos.', 'Advertencia!');
    } else if (this.email2.value.length < 10 ){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Confirmar correo debe tener mínimo 10 caracteres.', 'Advertencia!');
    } else if (this.email2.value.length > 40 ){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Confirmar correo debe tener máximo 40 caracteres.', 'Advertencia!');
    } else if(this.email1.value!=this.email2.value) {
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('El correo no es igual.', 'Advertencia!');
    } else if(!this.checkEmailValidity1() || !this.checkEmailValidity2()) {
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Correo no valido.', 'Advertencia!');
    } else if (this.datosUsuarioEdit.telefono == ""){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Ingresar número telefonico.', 'Advertencia!');
    } else if (this.datosUsuarioEdit.telefono.length < 7){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Teléfono debe tener mínimo 7 caracteres.', 'Advertencia!');
    } else if (this.datosUsuarioEdit.telefono.length > 10){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Teléfono debe tener máximo 10 caracteres.', 'Advertencia!');
    } else if (this.datosUsuarioEdit.extencion == ""){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Ingresar extención.', 'Advertencia!');
    } else if (this.datosUsuarioEdit.extencion.length < 2){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Extención debe tener mínimo 2 caracteres.', 'Advertencia!');
    } else if (this.datosUsuarioEdit.extencion.length > 5){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Extención debe tener máximo 5 caracteres.', 'Advertencia!');
    } else if (this.datosUsuarioEdit.cargo == ""){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Ingresar cargo.', 'Advertencia!');
    } else if (this.datosUsuarioEdit.cargo.length < 5){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('El cargo debe tener mínimo 5 caracteres.', 'Advertencia!');
    } else if (this.datosUsuarioEdit.cargo.length > 20){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('El cargo debe tener máximo 20 caracteres.', 'Advertencia!');
    } else{
      if (this.continuar){
        this.btnguardar = true;
        this.datosUsuarioEdit.correo = this.email1.value;
        this.api.editarUsuario(this.datosUsuarioEdit).
        subscribe(data=>{
          this.toastr.success('Cambios guardados.', 'OK!');
          this.router.navigate(['usuarios']);
        },error=>{
          console.log(error);
        });
      } else {
        this.btnguardar = false;
        this.toastr.error('No se pudo crear.', 'Error!');
      }
    }
  }

  cambiarTipoUsuario(tipo){
    this.api.getTipoUsuarioById(tipo).subscribe(data=>{
      this.tipoUsuDaneSeclte = data;
    },error=>{
      console.log(error);
    });
  }

  cambiarTipoUsuarioDane(tipoUsuario){
    this.datosUsuarioEdit.tipoUsuario = this.tiposUsuarioDane.find(function(tipo) {
      if (tipo.idTipoUsuario == tipoUsuario) return tipo;
      else return null;
    });
    if(tipoUsuario==1){
      let nuevasPrimerasDosLetras = "AD";
      this.datosUsuarioEdit.username = nuevasPrimerasDosLetras + this.datosUsuarioEdit.username.substring(2);
    }else if(tipoUsuario==2){
      let nuevasPrimerasDosLetras = "TE";
      this.datosUsuarioEdit.username = nuevasPrimerasDosLetras + this.datosUsuarioEdit.username.substring(2);
    }else if(tipoUsuario==3){
      let nuevasPrimerasDosLetras = "OP";
      this.datosUsuarioEdit.username = nuevasPrimerasDosLetras + this.datosUsuarioEdit.username.substring(2);
    }
  }

  checkEmailValidity1() {
    const atIndex = this.email1.value.indexOf('@');
    if (atIndex !== -1) {
      const domain = this.email1.value.substring(atIndex + 1);
      if (domain.indexOf('.') !== -1) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  checkEmailValidity2() {
    const atIndex = this.email2.value.indexOf('@');
    if (atIndex !== -1) {
      const domain = this.email2.value.substring(atIndex + 1);
      if (domain.indexOf('.') !== -1) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  regresar(){
    this.router.navigate(['usuarios']);
  }


  guardarUsuarioDane(){

    this.btnguardar = true;
    this.continuar = true;

    if (this.datosUsuarioEdit.tipoIdent == ""){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Seleccione un tipo de identificación.', 'Advertencia!');
    } else if (this.datosUsuarioEdit.identificacion == ""){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Ingresar número de identificación.', 'Advertencia!');
    } else if (this.datosUsuarioEdit.identificacion.length < 6){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('El número de identificación debe contar con mínimo 6 caracteres.', 'Advertencia!');
    } else if (this.datosUsuarioEdit.identificacion.length >10){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('El número de identificación debe contar con máximo 10 caracteres.', 'Advertencia!');
    } if (this.datosUsuarioEdit.nombres == ""){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Ingresar nombres.', 'Advertencia!');
    } else if (this.datosUsuarioEdit.nombres.length < 4){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('El nombre del responsable debe contar con mínimo 4 caracteres.', 'Advertencia!');
    } else if (this.datosUsuarioEdit.nombres.length > 100){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('El nombre del responsable debe contar con máximo 100 caracteres.', 'Advertencia!');
    } else if (this.datosUsuarioEdit.apellidos == ""){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Ingresar apellidos.', 'Advertencia!');
    } else if (this.datosUsuarioEdit.apellidos.length < 4){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Apellidos del responsable debe contar con mínimo 4 caracteres.', 'Advertencia!');
    } else if (this.datosUsuarioEdit.apellidos.length > 100){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Apellidos del responsable debe contar con máximo 100 caracteres.', 'Advertencia!');
    } else if (this.email1.value == ""){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Ingresar correo.', 'Advertencia!');
    } else if (this.email1.hasError('required')){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Ingresar correo.', 'Advertencia!');
    } else if (this.email1.hasError('email')){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Correo no valido.', 'Advertencia!');
    } else if (this.email1.hasError('pattern')){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Correo contiene caracteres no permitidos.', 'Advertencia!');
    } else if (this.email1.value.length < 10 ){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Correo debe tener mínimo 10 caracteres.', 'Advertencia!');
    } else if (this.email1.value.length > 40 ){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Correo debe tener máximo 40 caracteres.', 'Advertencia!');
    } else if (this.email2.value == ""){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Confirmar correo .', 'Advertencia!');
    } else if (this.email2.hasError('required')){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Confirmar correo.', 'Advertencia!');
    } else if (this.email2.hasError('email')){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Confirmar correo no valido.', 'Advertencia!');
    } else if (this.email2.hasError('pattern')){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Confirmar correo contiene caracteres no permitidos.', 'Advertencia!');
    } else if (this.email2.value.length < 10 ){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Confirmar correo debe tener mínimo 10 caracteres.', 'Advertencia!');
    } else if (this.email2.value.length > 40 ){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Confirmar correo debe tener máximo 40 caracteres.', 'Advertencia!');
    } else if(this.email1.value!=this.email2.value) {
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('El correo no es igual.', 'Advertencia!');
    } else if(!this.checkEmailValidity1() || !this.checkEmailValidity2()) {
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Correo no valido.', 'Advertencia!');
    } else if (this.datosUsuarioEdit.telefono == ""){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Ingresar número telefonico.', 'Advertencia!');
    } else if (this.datosUsuarioEdit.telefono.length < 7){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Teléfono debe tener mínimo 7 caracteres.', 'Advertencia!');
    } else if (this.datosUsuarioEdit.telefono.length > 10){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Teléfono debe tener máximo 10 caracteres.', 'Advertencia!');
    } else if (this.datosUsuarioEdit.extencion == ""){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Ingresar extención.', 'Advertencia!');
    } else if (this.datosUsuarioEdit.extencion.length < 2){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Extención debe tener mínimo 2 caracteres.', 'Advertencia!');
    } else if (this.datosUsuarioEdit.extencion.length > 5){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Extención debe tener máximo 5 caracteres.', 'Advertencia!');
    } else if (this.datosUsuarioEdit.cargo == ""){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Ingresar cargo.', 'Advertencia!');
    } else if (this.datosUsuarioEdit.cargo.length < 5){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('El cargo debe tener mínimo 5 caracteres.', 'Advertencia!');
    } else if (this.datosUsuarioEdit.cargo.length > 20){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('El cargo debe tener máximo 20 caracteres.', 'Advertencia!');
    } else{
      if (this.continuar){
        this.btnguardar = true;
        this.datosUsuarioEdit.correo = this.email1.value;
        this.api.editarUsuario(this.datosUsuarioEdit).
        subscribe(data=>{
          this.toastr.success('Cambios guardados.', 'OK!');
          this.router.navigate(['usuarios']);
        },error=>{
          console.log(error);
        });
      } else {
        this.btnguardar = false;
        this.toastr.error('No se pudo crear.', 'Error!');
      }
    }
  }

}
